// extracted by mini-css-extract-plugin
export default {"orders":"Orders_orders__pYH40"};